import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/pricing/#webpage",
   "url": "https://www.futurefamilyai.com/pricing/",
   "name": "Pregnancy Monitoring App Cost & Free Pilot | FutureFamilyAI",
   "description": "Join free through Dec 31, 2026 — no subscription fee. After the pilot: $39.99/month or $399/year. Devices purchased separately.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Kulsoom Baloch, MBBS, MPH",
    "jobTitle": "Clinical Protocol Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#kulsoom-baloch",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Pricing",
     "item": "https://www.futurefamilyai.com/pricing/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is FutureFamilyAI free?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, during the pilot: eligible participants pay no subscription fee through December 31, 2026. Afterward, Complete Monitoring is $39.99/month or $399/year."
     }
    },
    {
     "@type": "Question",
     "name": "What happens when the pilot ends?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "We will notify you before any charge. You can choose a monthly or annual plan, or export your data and leave."
     }
    },
    {
     "@type": "Question",
     "name": "How much does a home blood pressure cuff cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Validated upper-arm cuffs typically cost about $50–$85. Check ValidateBP.org for validated models."
     }
    },
    {
     "@type": "Question",
     "name": "Does insurance cover a blood pressure monitor during pregnancy?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many plans and FSA/HSA accounts cover home blood pressure monitors when recommended by a clinician. Check with your plan."
     }
    },
    {
     "@type": "Question",
     "name": "Do surrogates pay?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many participating surrogacy agencies provide FutureFamilyAI at no cost to surrogates."
     }
    },
    {
     "@type": "Question",
     "name": "Is there a contract?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No long-term contract. Monthly plans can be cancelled any time."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  },
  {
   "@type": "MobileApplication",
   "name": "FutureFamilyAI",
   "operatingSystem": "iOS, Android",
   "applicationCategory": "HealthApplication",
   "offers": [
    {
     "@type": "Offer",
     "price": "0",
     "priceCurrency": "USD",
     "description": "Free pilot through December 31, 2026",
     "priceValidUntil": "2026-12-31"
    },
    {
     "@type": "Offer",
     "price": "39.99",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, monthly (after pilot)"
    },
    {
     "@type": "Offer",
     "price": "399",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, annual (after pilot)"
    }
   ],
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   }
  }
 ]
}`;

export default function PricingPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Pricing</span>
            </nav>
             <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  {/* <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span> */}
                  <h1>
                 The Right Support for Your Pregnancy Journey
                  </h1>
                  
                  <p className="ffh-lead speakable-content">
Explore FutureFamilyAI plans designed to help you stay connected to your pregnancy wellness. Track blood pressure and wellness trends, access monitoring insights, and stay connected with your healthcare provider with a plan that fits your needs.                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Clear Plans. Connected Care. Greater Peace of Mind.
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">View Pricing Plans </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">Compare Features</a>
                    </div>

                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                 <iframe width="100%" height="365" src="https://www.youtube.com/embed/YzxH01Vkikk" title="FutureFamilyAI Pricing | Free Pilot Through December 31, 2026" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                FutureFamilyAI is free for eligible pilot participants through
                December 31, 2026 — no subscription fee.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Expecting &amp; planning mothers; surrogates</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Validated upper-arm devices are recommended for
                      self-measured blood pressure; wrist and finger devices are
                      not recommended for routine use. (AHA/AMA Joint Policy
                      Statement, 2020)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      $0 subscription during the pilot · Plain list price
                      afterward — no hidden tiers · Surrogates often covered by
                      their agency
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact-us/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">SIMPLE, TRANSPARENT PRICING</span>
            <h1>Pregnancy Monitoring App Cost — Start Free in the Pilot</h1>
            <p className="ffh-answer speakable-content">
              FutureFamilyAI is free for eligible pilot participants through
              December 31, 2026 — no subscription fee. After the pilot, Complete
              Monitoring is $39.99 per month or $399 per year (about two months
              free). You&apos;ll need a compatible phone and a validated
              upper-arm cuff (typically $50–$85); an Apple Watch or Samsung
              Galaxy Watch adds wearable trends. Devices are purchased
              separately. Request free pilot access.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#kulsoom-baloch">
                    Dr. Kulsoom Baloch, MBBS, MPH
                  </Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Devices used with FutureFamilyAI: iPhone, smartwatch and validated cuff"
              >
                <img
                  src="/images/clean-product.jpg"
                  alt="Devices used with FutureFamilyAI: iPhone,  smartwatch and validated cuff" />
               
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Validated upper-arm devices are recommended for
                    self-measured blood pressure; wrist and finger devices are
                    not recommended for routine use.
                    <cite>
                      Source:{" "}
                      <a href="https://www.ahajournals.org/doi/10.1161/CIR.0000000000000803">
                        AHA/AMA Joint Policy Statement, 2020
                      </a>
                    </cite>
                  </li>
                  <li>
                    The U.S. Validated Device Listing identifies home blood
                    pressure monitors that meet clinical validation criteria.
                    <cite>
                      Source:{" "}
                      <a href="https://www.validatebp.org">
                        AMA / ValidateBP.org
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Free Pilot</h2>
                <ul>
                  <li>$0 subscription through December 31, 2026</li>
                  <li>Blood pressure and wellness trends</li>
                  <li>Care-team review of Orange/Red status</li>
                  <li>Postpartum monitoring</li>
                  <li>Provider and partner sharing controls</li>
                </ul>
              </section>
              <section id="s2">
                <h2>Complete Monitoring (after the pilot)</h2>
                <ul>
                  <li>$39.99 per month</li>
                  <li>Everything in the pilot</li>
                  <li>Cancel any time</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="s3">
                <h2>Complete — Annual (after the pilot)</h2>
                <ul>
                  <li>$399 per year — about two months free</li>
                  <li>Everything in Complete Monitoring</li>
                  <li>
                    Optional DNA carrier-screening add-on (priced separately)
                  </li>
                </ul>
              </section>
              <section id="s4">
                <h2>What&apos;s not included</h2>
                <p>
                  Devices, laboratory fees for carrier screening, clinician
                  visits and insurance copays are separate. We will tell you
                  before any subscription charge begins.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>Is FutureFamilyAI free?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes, during the pilot: eligible participants pay no
                        subscription fee through December 31, 2026. Afterward,
                        Complete Monitoring is $39.99/month or $399/year.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>What happens when the pilot ends?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        We will notify you before any charge. You can choose a
                        monthly or annual plan, or export your data and leave.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      How much does a home blood pressure cuff cost?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Validated upper-arm cuffs typically cost about $50–$85.
                        Check ValidateBP.org for validated models.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does insurance cover a blood pressure monitor during
                      pregnancy?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Many plans and FSA/HSA accounts cover home blood
                        pressure monitors when recommended by a clinician. Check
                        with your plan.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Do surrogates pay?</summary>
                    <div className="ffh-ans">
                      <p>
                        Many participating surrogacy agencies provide
                        FutureFamilyAI at no cost to surrogates.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is there a contract?</summary>
                    <div className="ffh-ans">
                      <p>
                        No long-term contract. Monthly plans can be cancelled
                        any time.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">KB</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Kulsoom Baloch, MBBS, MPH</h3>
                  <p>
                    Clinical Protocol Author, FutureFamilyAI. Dr. Kulsoom
                    Baloch, MBBS, MPH, is the clinical protocol author for
                    FutureFamilyAI and a published researcher in reproductive
                    and maternal health. She developed the app&apos;s monitoring
                    protocol using ACOG, SMFM, ISSHP and AHA guidance.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/how-it-works">How It Works →</Link>
                  <Link to="/pregnancy-monitoring">Pregnancy Monitoring →</Link>
                  <Link to="/about">About &amp; Clinical Oversight →</Link>
                  <Link to="/privacy-safety">Privacy &amp; Safety →</Link>
                  <Link to="/faq">Frequently Asked Questions →</Link>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Free Pilot</a>
                  </li>
                  <li>
                    <a href="#s2">Complete Monitoring (after the pilot)</a>
                  </li>
                  <li>
                    <a href="#s3">Complete — Annual (after the pilot)</a>
                  </li>
                  <li>
                    <a href="#s4">What&apos;s not included</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
